// components/LibraryCategories.jsx
import axios from "axios";
import React, { useEffect, useState } from "react";

const LibraryCategories = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    title_ar: "",
  });
  const [flag, setFlag] = useState(false);
  const [categories, setCategories] = useState([
    { id: 1, title: "Science & Technology", bookCount: 45 },
    { id: 2, title: "Literature & Fiction", bookCount: 78 },
    { id: 3, title: "History & Biography", bookCount: 32 },
    { id: 4, title: "Business & Economics", bookCount: 23 },
    { id: 5, title: "Art & Photography", bookCount: 15 },
  ]);

  // Handle Add/Edit Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isEditing && editingCategory) {
      // Update existing category
      await axios.patch(
        process.env.REACT_APP_BASE_URL +
          "library-category/update-library-category",
        null,
        {
          params: {
            category_id: editingCategory.id,
            ...formData,
          },
        }
      );
      setFlag(!flag);
    } else {
      await axios.post(
        process.env.REACT_APP_BASE_URL +
          "library-category/add-library-category",
        formData
      );
      setFlag(!flag);
    }

    resetForm();
  };

  // Handle Edit
  const handleEdit = (category) => {
    setFormData({
      title: category.title,
      title_ar: category.title_ar,
    });
    setEditingCategory(category);
    setIsEditing(true);
    setIsAdding(true);
  };

  // Handle Delete
  const handleDelete = async (categoryId) => {
    // setCategories(categories.filter((c) => c.id !== categoryId));
    await axios.delete(
      process.env.REACT_APP_BASE_URL +
        "library-category/delete-library-category",
      {
        params: {
          category_id: categoryId,
        },
      }
    );
    setFlag(!flag);
  };

  // Reset form and states
  const resetForm = () => {
    setFormData({ title: "" });
    setIsAdding(false);
    setIsEditing(false);
    setEditingCategory(null);
  };

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Get category color intensity based on book count
  const getCategoryColor = (bookCount) => {
    if (bookCount >= 50) return "from-green-700 to-green-800";
    if (bookCount >= 30) return "from-green-600 to-green-700";
    if (bookCount >= 20) return "from-green-500 to-green-600";
    if (bookCount >= 10) return "from-green-400 to-green-500";
    return "from-green-300 to-green-400";
  };

  // Get progress bar color based on book count
  const getProgressColor = (bookCount) => {
    if (bookCount >= 50) return "bg-green-700";
    if (bookCount >= 30) return "bg-green-600";
    if (bookCount >= 20) return "bg-green-500";
    if (bookCount >= 10) return "bg-green-400";
    return "bg-green-300";
  };

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "library-category/get-all-library-category"
      )
      .then((res) => setCategories(res.data.data));
  }, [flag]);

  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Categories</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {categories.length}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📑</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Books</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {categories.reduce((sum, c) => sum + c.bookCount, 0)}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📚</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Avg Books/Category</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {Math.round(
                  categories.reduce((sum, c) => sum + c.bookCount, 0) /
                    categories.length
                )}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📊</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Popular Category</p>
              <p className="text-lg font-bold text-gray-800 mt-2 truncate">
                {
                  categories.reduce(
                    (max, c) => (c.bookCount > max.bookCount ? c : max),
                    categories[0]
                  )?.title
                }
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">⭐</span>
            </div>
          </div>
        </div>
      </div>

      {/* Header with Add Button */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Library Categories
          </h2>
          <p className="text-gray-600 mt-1">
            Organize your library with categories and collections
          </p>
        </div>
        <button
          onClick={() => setIsAdding(true)}
          className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center space-x-2 group"
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            +
          </span>
          <span>Add Category</span>
        </button>
      </div>

      {/* Add/Edit Category Form Modal */}
      {isAdding && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md transform animate-scale-in">
            <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
              <h3 className="text-xl font-bold text-gray-800">
                {isEditing ? "Edit Category" : "Add New Category"}
              </h3>
              <p className="text-green-600 text-sm mt-1">
                {isEditing
                  ? "Update the category details"
                  : "Create a new library category"}
              </p>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Category Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter category title"
                />
                <p className="text-sm text-gray-500 mt-2">
                  Choose a descriptive name for your library category
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Category Title Arabic *
                </label>
                <input
                  type="text"
                  name="title_ar"
                  value={formData.title_ar}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter category title"
                />
                <p className="text-sm text-gray-500 mt-2">
                  Choose a descriptive name for your library category
                </p>
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  {isEditing ? "Update Category" : "Add Category"}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Categories Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {categories.map((category, index) => (
          <div
            key={category.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 group animate-fade-in border border-green-100"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {/* Category Header */}
            <div
              className={`bg-gradient-to-r ${getCategoryColor(
                category.bookCount
              )} p-6 text-white`}
            >
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <span className="text-xl">📚</span>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold">{category.bookCount}</p>
                  <p className="text-sm opacity-90">Books</p>
                </div>
              </div>
            </div>

            {/* Category Content */}
            <div className="p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-200 line-clamp-2">
                {category.title}
              </h3>

              {/* Progress Bar */}
              <div className="mb-4">
                <div className="flex justify-between text-sm text-gray-600 mb-1">
                  <span>Collection Size</span>
                  <span>{category.bookCount} books</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className={`h-2 rounded-full ${getProgressColor(
                      category.bookCount
                    )} transition-all duration-500`}
                    style={{
                      width: `${Math.min(
                        (category.bookCount / 100) * 100,
                        100
                      )}%`,
                    }}
                  ></div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-2">
                <button
                  onClick={() => handleEdit(category)}
                  className="flex-1 bg-green-50 text-green-600 py-2 px-3 rounded-lg font-medium hover:bg-green-100 transition-colors duration-200 flex items-center justify-center space-x-1 text-sm"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                  <span>Edit</span>
                </button>
                <button
                  onClick={() => handleDelete(category.id)}
                  className="flex-1 bg-red-50 text-red-600 py-2 px-3 rounded-lg font-medium hover:bg-red-100 transition-colors duration-200 flex items-center justify-center space-x-1 text-sm"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                  <span>Delete</span>
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Add New Category Card */}
        <div
          className="border-2 border-dashed border-green-300 rounded-2xl p-8 text-center hover:border-green-500 hover:bg-green-50 transition-all duration-300 cursor-pointer group"
          onClick={() => setIsAdding(true)}
        >
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors duration-200">
            <span className="text-2xl text-green-600 group-hover:scale-110 transition-transform duration-200">
              +
            </span>
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2 group-hover:text-green-700 transition-colors duration-200">
            Add New Category
          </h3>
          <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors duration-200">
            Create a new library category to organize your books
          </p>
        </div>
      </div>

      {/* Empty State */}
      {categories.length === 0 && (
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl text-green-600">📚</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No categories yet
          </h3>
          <p className="text-gray-500 mb-6 max-w-md mx-auto">
            Organize your library by creating categories. This helps users find
            books more easily.
          </p>
          <button
            onClick={() => setIsAdding(true)}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            Create First Category
          </button>
        </div>
      )}

      {/* Quick Stats Footer */}
      {categories.length > 0 && (
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div>
              <p className="text-sm opacity-90">Total Categories</p>
              <p className="text-2xl font-bold">{categories.length}</p>
            </div>
            <div>
              <p className="text-sm opacity-90">Total Books</p>
              <p className="text-2xl font-bold">
                {categories.reduce((sum, c) => sum + c.bookCount, 0)}
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Largest Category</p>
              <p className="text-lg font-bold truncate">
                {
                  categories.reduce(
                    (max, c) => (c.bookCount > max.bookCount ? c : max),
                    categories[0]
                  )?.title
                }
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Avg Books</p>
              <p className="text-2xl font-bold">
                {Math.round(
                  categories.reduce((sum, c) => sum + c.bookCount, 0) /
                    categories.length
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LibraryCategories;
